export const CATEGORIES = ['abstract', 'people', 'animals', 'nature'];
export const PACE = ['easy', 'medium', 'hard', 'pro'];
export const INITIAL_CARDS_COUNT = 8;
